import api from "../../api";

const state = {
  status: "",
  ID: "",
  CreatedAt: "",
  UpdatedAt: "",
  DeletedAt: null,
  UserID: "",
  Avatar: "",
  Email: "",
  Firstname: "",
  Surname: "",
  Phone: "",
  City: "",
  Country: "",
  Skills: [],
  AccountName: "",
  AccountNumber: "",
  BankName: "",
  Language: "",
  Currency: "",
  InviteLink: "",
  EmailNewsletter: "",
  EmailPaymentReceipt: "",
  EmailNewProjectUploaded: "",
  EmailMilestoneApproved: "",
  EmailNewMemberAdded: "",
};

const getters = {
  fullName: (state) => state.Firstname + state.Surname,
};

const mutations = {
  all_settings() {},
};

const actions = {
  userSettings({ commit, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `settings/${rootState.user.id}`,
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },

  updateSettings({ commit, rootState, rootGetters }, user) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `settings/${rootState.user.id}/${user.type}`,
        method: "PUT",
        data: user.data,
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },
  updatePassword({ commit, rootState, rootGetters }, user) {
    return new Promise((resolve, reject) => {
      commit("make_request", null, { root: true });
      api({
        url: `users/${rootState.user.id}`,
        method: "PUT",
        data: user,
        withCredentials: true,
        headers: {
          Authorization: rootGetters.authToken,
        },
      })
        .then((resp) => {
          commit("request_success", null, { root: true });
          resolve(resp);
        })
        .catch((err) => {
          commit("request_error", null, { root: true });
          reject(err);
        });
    });
  },
};

export const settings = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
